import axios from "axios";
import { BE_API } from "../../../app/config/constants";
import { SubscribeUserRequest } from "../models/common.models";

const API = {
  subscribeUser: (data: SubscribeUserRequest) => axios.post(`${BE_API}/subscriptions/subscribe`, data)
}

export default API;
